export default {
  '847ef1be8c5c20ddf71c2b8156c22dbf': 'Hint',
  c694fdd9779381317352b6e1ed03267d: 'Unbound for the time being',
  f510e72ea1ba87e3f7ed5600830272cc: 'Unbind the account',
  '4f4309e2c1e3390d19259e3523ec04d8':
    'According to the requirements of national policies, for express items sent to Taiwan region, the ID number needs to be filled in. Please fill it in',
  d4a6b6cff9ce229a3caa981e66786528: 'Cancel',
  d32275e7d418ae7ed2945adedc040ec7: 'Go and supplement',
  '596ccc86ae49ea544182222542c3b54f': 'Sorry, the price has changed!',
  b4ae53838c0e0f8eb3a3497fe4a8e8a9: 'Sorry, the order creation failed!',
  '381b884bbcb1d33eccd70e3b19ee595a': 'System error',
  '6fad4422b2105c2f7e5382aa64a49e6a': 'In-app purchase items have expired',
  '6fad4422b2105c2f7e5382aa64a49e6b': 'Payment success'
};
